var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyBusiness({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    height: 512,
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m482 198.864h-326l100 283.136h226z",
    fill: "#4175df"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30 198.864h226v283.136h-226z",
    fill: "#4086f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m192 156.75 64 86.25c0 35.346 28.654 64 64 64s64-28.654 64-64l64-86.25z",
    fill: "#609af6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m384 156.75v86.25c0 35.346 28.654 64 64 64s64-28.654 64-64v-26.25z",
    fill: "#23346d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64 156.75 64 86.25c0 35.346 28.654 64 64 64s64-28.654 64-64v-86.25z",
    fill: "#324492"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 216.75v26.25c0 35.346 28.654 64 64 64s64-28.654 64-64v-86.25z",
    fill: "#80aef8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.24 30-65.24 186.75h128l64-93.375-31.38-93.375z",
    fill: "#9fc2f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m512 216.75-65.24-186.75h-95.38l-31.38 93.375 64 93.375z",
    fill: "#324492"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m351.38 30h-95.38l-64 93.375 64 93.375h128z",
    fill: "#80aef8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160.62 30-32.62 186.75h128v-186.75z",
    fill: "#4254b6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyBusiness);
export default __webpack_public_path__ + "static/media/my-business.9490f97dd824bd113b71fd4119169ec1.svg";
export { ForwardRef as ReactComponent };